/* eslint-disable @typescript-eslint/triple-slash-reference */
// tslint:disable-next-line: no-reference
/// <reference path='../../images.d.ts'/>
import { ReactComponent as MicrosoftLogo } from '../../assets/svg/microsoft-logo.svg';
export default MicrosoftLogo;
